import styled from 'styled-components';
import { isThemeColor, defaultTransition } from 'styles/utils';
import { FrameHeaderHeight } from 'styles/constants';
import { Avatar } from 'apps/components/shared';

export const MainCollaboratorsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: ${FrameHeaderHeight}px;
`;

const circleSize = '24px';

const statusOpacity = status => {
  if (status === 'INVITED' || status === 'OFFLINE') return 0.5;
  return 1;
};

export const CircleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${Avatar} {
    width: ${circleSize};
    height: ${circleSize};
    opacity: ${props => statusOpacity(props.status)};
  }
  border: ${props =>
    isThemeColor(props.borderColor)
      ? `1px solid ${props.theme.color[props.borderColor]}`
      : 'initial'};
  background-color: ${props =>
    isThemeColor(props.backgroundColor)
      ? `${props.theme.color[props.backgroundColor]}`
      : 'initial'};
  cursor: pointer;
`;

export const CirclesRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 1rem;

  div {
    margin: -2px;
  }
`;

export const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 1rem;
  cursor: pointer;

  h5 {
    color: ${props => props.theme.color.wfWhite};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  ${defaultTransition('opacity')}
  &:hover {
    opacity: 0.8;
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  height: 100%;
`;

export const NoOtherCollaboratorsButton = styled.button`
  color: white;
  display: flex;
  align-items: center;
  font-size: ${props => props.theme.font.size.small};

  gap: ${props => props.theme.spacing.small};
  padding: 0 ${props => props.theme.spacing.default};

  border: none;

  ${defaultTransition('opacity')}
  &:hover {
    opacity: 0.8;
  }
`;
